module.exports = __webpack_public_path__ + "img/IMG_3119_L_Wood.548032b3.jpg";